// Tema visual del terminal, recordado por equipo.
//
// Mismo patrón que zoomDetalleService.js, ticketPrintConfigService.js y
// listColumnsPreferenceService.js: localStorage y una clave. No hay tabla de
// preferencias en Dexie, y ésta no debería viajar a Business Central: el tema
// es de la pantalla que se tiene delante, no del cajero. La misma persona en el
// mostrador de día y en la trastienda de noche puede querer cosas distintas.
const STORAGE_KEY = "tema";

/** Lo que se puede elegir. «sistema» sigue al del equipo. */
export const TEMAS = ["claro", "oscuro", "sistema"];

// Por omisión, claro.
//
// Lo natural sería seguir al sistema, y es lo que hace la mayoría de las
// aplicaciones nuevas. Acá no: esto se instala en cajas que ya están
// trabajando, y un equipo con Windows en oscuro amanecería con el terminal
// cambiado sin que nadie lo pidiera. Que lo elija quien lo quiera.
const POR_OMISION = "claro";

/** La consulta con la que se le pregunta al sistema. */
export const CONSULTA_OSCURO = "(prefers-color-scheme: dark)";

export const getTemaPreferido = () => {
  try {
    const guardado = localStorage.getItem(STORAGE_KEY);
    return TEMAS.includes(guardado) ? guardado : POR_OMISION;
  } catch (error) {
    console.error("Error al leer el tema guardado:", error);
    return POR_OMISION;
  }
};

export const setTemaPreferido = (tema) => {
  try {
    localStorage.setItem(STORAGE_KEY, TEMAS.includes(tema) ? tema : POR_OMISION);
  } catch (error) {
    console.error("Error al guardar el tema:", error);
  }
};

/** Si el equipo está puesto en oscuro. */
export const sistemaEnOscuro = () => {
  try {
    return window.matchMedia?.(CONSULTA_OSCURO)?.matches === true;
  } catch (error) {
    return false;
  }
};

/**
 * El tema que toca pintar: «claro» u «oscuro», nunca «sistema».
 *
 * Un valor que no se reconoce cae en claro y **no** en el del sistema. Es la
 * diferencia entre «no sé qué quiere» y «quiere lo que diga el equipo», y sólo
 * la segunda se pidió expresamente: una preferencia corrupta no debe estrenar
 * un tema que nadie eligió.
 */
export const resolverTema = (preferencia, sistemaOscuro = false) => {
  if (preferencia === "oscuro") return "oscuro";
  if (preferencia === "sistema") return sistemaOscuro ? "oscuro" : "claro";
  return "claro";
};
